// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-components-modules-Hero-style----general-module---hero---WGSlS paddingTop-l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/style/general.module.css
// module id = 252
// module chunks = 168707334958949